"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
var _a, _b, _c;
Object.defineProperty(exports, "__esModule", { value: true });
exports.TrainerConfig = void 0;
const T = __importStar(require("@microsoft/fast-element"));
const fast_element_1 = require("@microsoft/fast-element");
require("./template.html");
const client_1 = require("@rws-framework/client");
const TrainerStorageService_1 = __importStar(require("../../services/TrainerStorageService"));
const trainer_types_1 = require("../../types/trainer.types");
const events_1 = require("../../events");
const component_1 = require("@front/components/form-parts/form/component");
const events_2 = require("@front/components/form-parts/events");
//@ts-ignore                
let rwsTemplate = T.html `<div class="config-section">
  <h2 class="mt-3 ml-3">⚙️ ${'trainer.config.title'.t()}</h2>
  
  <the-form :onSubmit="${x => x.sendForm.bind(x)}">
    
    <div class="config-group">
      <h3>${'trainer.config.basic'.t()}</h3>
      
      <div class="form-group">
        <part-input 
          class="form-part"
          label="${'trainer.config.model.name.required'.t()}"
          :value="${x => x.trainingConfig.modelName}"
          name="modelName"
          placeholder="${'trainer.config.model.name.placeholder'.t()}"
          required="true"
        ></part-input>
      </div>
      
      <div class="form-group">
        <label>${'trainer.config.base.model'.t()}</label>
        <model-select   
            training="true"
            mainProvider="together"            
            :onChange="${(x, c) => x.onModelSelect.bind(x)}">
        </model-select>
        
        ${(0, fast_element_1.when)(x => x.trainingConfig.baseModel && x.trainingConfig.baseModel.model && x.trainingConfig.baseModel.model.description.split(',').length, (0, fast_element_1.html) `
          <div class="model-desc">
            ${(0, fast_element_1.repeat)(x => x.trainingConfig.baseModel.model.description.split(','), (0, fast_element_1.html) `<span class="model-desc-pill">${x => x}</span>`)}
          </div>
        `)}
      </div>
      
      <div class="form-group">
        ${x => console.log(x.trainingConfig.useFineTuning)}
        <part-radio 
          class="form-part"
          label="${'trainer.config.fine.tuning'.t()}"
          value="${x => x.trainingConfig.useFineTuning}"
          :options="${x => x.fineTuningOptions}"
          name="useFineTuning"
        ></part-radio>
      </div>
    </div>

    
    <div class="config-group">
      <h3>
        ${'trainer.config.advanced'.t()} 
        <button 
          type="button"
          class="toggle-button" 
          @click="${x => x.toggleAdvancedConfig()}">
          ${x => x.showAdvancedConfig ? '🔼 ' + 'trainer.config.advanced.hide'.t() : '🔽 ' + 'trainer.config.advanced.show'.t()}
        </button>
      </h3>
      
      <div class="advanced-config" ?hidden="${x => !x.showAdvancedConfig}">
        <div class="form-row">
          <div class="form-group col-md-6">
            <part-input 
              class="form-part"
              label="${'trainer.config.epochs'.t()}"
              :value="${x => x.trainingConfig.epochs}"
              name="epochs"
              type="number"
              min="1"
              max="100"
            ></part-input>
            <small class="form-text text-muted">${'trainer.config.epochs.help'.t()}</small>
          </div>
          
          <div class="form-group col-md-6">
            <part-input 
              class="form-part"
              label="${'trainer.config.learning.rate'.t()}"
              :value="${x => x.trainingConfig.learningRate}"
              name="learningRate"
              type="number"
              min="0.0001"
              max="0.1"
              step="0.0001"
            ></part-input>
            <small class="form-text text-muted">${'trainer.config.learning.rate.help'.t()}</small>
          </div>
        </div>
        
        <div class="form-row">
          <div class="form-group col-md-6">
            <part-select 
              class="form-part"
              label="${'trainer.config.batch.size'.t()}"
              :value="${x => x.trainingConfig.batchSize}"
              name="batchSize"
              :options="${x => x.batchSizeOptions}"
            ></part-select>
            <small class="form-text text-muted">${'trainer.config.batch.size.help'.t()}</small>
          </div>
          
          <div class="form-group col-md-6">
            <part-input 
              class="form-part"
              label="${'trainer.config.validation.split'.t()}"
              :value="${x => x.trainingConfig.validationSplit}"
              name="validationSplit"
              type="number"
              min="0.1"
              max="0.5"
              step="0.05"
            ></part-input>
            <small class="form-text text-muted">${'trainer.config.validation.split.help'.t()}</small>
          </div>
        </div>       
      </div>
      <button class="btn btn-primary" @click="${(x, c) => x.sendSubmit(x, c)}">
        ${'trainer.config.train'.t()}
      </button>
    </div>
  </the-form>
</div>
`;
require("./styles/layout.scss");
const styles = T.css `:host {
  display: block;
  width: 100%;
}

.config-section h2 {
  margin: 0 0 2rem 0;
  color: #334155;
}
.config-section .config-group {
  margin-bottom: 2rem;
  padding: 1.5rem;
  background: #f8fafc;
  border-radius: 8px;
  border: 1px solid #e2e8f0;
}
.config-section .config-group h3 {
  margin: 0 0 1rem 0;
  color: #334155;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.config-section .config-group h3 .toggle-button {
  background: transparent;
  border: none;
  color: #667eea;
  cursor: pointer;
  font-size: 0.9rem;
  font-weight: 500;
  padding: 0.5rem;
  border-radius: 4px;
  transition: background-color 0.2s;
}
.config-section .config-group h3 .toggle-button:hover {
  background: #e2e8f0;
}
.config-section .config-group .model-desc {
  margin: 15px 0;
  display: flex;
  flex-direction: row;
  gap: 10px;
}
.config-section .config-group .model-desc .model-desc-pill {
  border-radius: 15px;
  font-size: 14px;
  background-color: #667eea;
  padding: 5px;
  color: #FFF;
}
.config-section .config-group .form-group {
  margin-bottom: 1rem;
}
.config-section .config-group .form-group .form-text {
  color: #64748b;
  font-size: 0.7rem;
  margin-top: 0.25rem;
  display: block;
}
.config-section .config-group .form-group .form-part .form-control {
  border: 1px solid #d1d5db;
  border-radius: 6px;
  transition: border-color 0.2s, box-shadow 0.2s;
}
.config-section .config-group .form-group .form-part .form-control:focus {
  border-color: #667eea;
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
}
.config-section .config-group .form-group .form-part label {
  font-weight: 600;
  color: #334155;
}
.config-section .config-group .form-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1rem;
}
@media (max-width: 768px) {
  .config-section .config-group .form-row {
    grid-template-columns: 1fr;
  }
}
.config-section .config-group .advanced-config {
  border-top: 1px solid #e2e8f0;
  padding-top: 1rem;
  margin-top: 1rem;
}

.message-container {
  margin-bottom: 1.5rem;
  padding: 1rem 1.5rem;
  border-radius: 8px;
  border-left: 4px solid;
}
.message-container.error {
  background: #fef2f2;
  border-color: #ef4444;
  color: #991b1b;
}
.message-container.error h3 {
  color: #dc2626;
  margin: 0 0 0.5rem 0;
}
.message-container.warning {
  background: #fffbeb;
  border-color: #f59e0b;
  color: #92400e;
}
.message-container.warning h3 {
  color: #d97706;
  margin: 0 0 0.5rem 0;
}
.message-container ul {
  margin: 0;
  padding-left: 1.5rem;
}
.message-container ul li {
  margin-bottom: 0.25rem;
}

model-select {
  position: relative;
  z-index: 5;
}

@media (max-width: 768px) {
  .config-section .config-group .form-row {
    grid-template-columns: 1fr;
  }
}`;
const shadowOptions = { "mode": "open" };
let TrainerConfig = class TrainerConfig extends client_1.RWSViewComponent {
    constructor(trainerStorageService) {
        super();
        this.trainerStorageService = trainerStorageService;
        this.parsedData = [];
        this.dataStatistics = {
            totalSamples: 0,
            averageInputLength: 0,
            averageOutputLength: 0,
            categories: [],
            qualityScore: 0
        };
        this.showAdvancedConfig = false;
        // Options for select components
        this.modelOptions = [
            { label: 'GPT-3.5 Turbo', value: 'gpt-3.5-turbo' },
            { label: 'GPT-4', value: 'gpt-4' },
            { label: 'Llama 2 7B', value: 'llama-2-7b' },
            { label: 'Llama 2 13B', value: 'llama-2-13b' },
            { label: 'Mistral 7B', value: 'mistral-7b' }
        ];
        this.batchSizeOptions = [
            { label: '8', value: 8 },
            { label: '16', value: 16 },
            { label: '32', value: 32 },
            { label: '64', value: 64 }
        ];
        this.fineTuningOptions = [
            { label: 'trainer.config.fine_tuning.lora_extension'.t(), value: 'lora' },
            { label: 'trainer.config.fine_tuning.fulltrain'.t(), value: 'fulltrain' }
        ];
        this.sendSubmit = component_1.FormComponent.sendSubmitEvent;
    }
    connectedCallback() {
        super.connectedCallback();
        console.log(this.trainerStorageService);
        this.trainingConfig = this.trainerStorageService.getDefaultTrainingConfig();
        // Load saved configuration
        const savedConfig = this.trainerStorageService.loadTrainingConfig();
        if (savedConfig) {
            this.trainingConfig = savedConfig;
        }
        // Listen for form changes
        this.on(events_2.inputEvents.changed, (event) => {
            component_1.FormComponent.assignFormValues.bind(this)('trainingConfig', event);
            console.log(this.trainingConfig);
            // Save to storage
            this.trainerStorageService.saveTrainingConfig(this.trainingConfig);
        });
    }
    async sendForm(event) {
        event.preventDefault();
        this.trainingConfig = { ...this.trainingConfig, isSent: true };
        this.$emit(events_1.trainerEvents.configUpdated, { config: this.trainingConfig });
    }
    onModelSelect(model) {
        this.trainingConfig = { ...this.trainingConfig, baseModel: model };
        // this.$emit(trainerEvents.configUpdated, { config: this.trainingConfig });  
    }
    toggleAdvancedConfig() {
        this.showAdvancedConfig = !this.showAdvancedConfig;
    }
};
exports.TrainerConfig = TrainerConfig;
__decorate([
    client_1.observable,
    __metadata("design:type", typeof (_b = typeof trainer_types_1.TrainingConfig !== "undefined" && trainer_types_1.TrainingConfig) === "function" ? _b : Object)
], TrainerConfig.prototype, "trainingConfig", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Array)
], TrainerConfig.prototype, "parsedData", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", typeof (_c = typeof trainer_types_1.DataStatistics !== "undefined" && trainer_types_1.DataStatistics) === "function" ? _c : Object)
], TrainerConfig.prototype, "dataStatistics", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], TrainerConfig.prototype, "showAdvancedConfig", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Object)
], TrainerConfig.prototype, "modelOptions", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Object)
], TrainerConfig.prototype, "batchSizeOptions", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Object)
], TrainerConfig.prototype, "fineTuningOptions", void 0);
exports.TrainerConfig = TrainerConfig = __decorate([
    (0, client_1.RWSView)('trainer-config', null, { template: rwsTemplate, styles, options: { shadowOptions } }),
    __param(0, (0, client_1.RWSInject)(TrainerStorageService_1.default)),
    __metadata("design:paramtypes", [typeof (_a = typeof TrainerStorageService_1.TrainerStorageServiceInstance !== "undefined" && TrainerStorageService_1.TrainerStorageServiceInstance) === "function" ? _a : Object])
], TrainerConfig);
TrainerConfig.defineComponent();
